module.exports = __webpack_public_path__ + "media/images/static/merits/merit_03-21b209799d9454395ea319a6c8035cc7.png";